import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { ErrorHandlerService } from '../services/index';
import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../reducers';
import { CategoryFormActions, SaveCategories,PriceLevelActions} from '../actions';
import { MessageActions} from '../actions/message.actions';
import { Response } from '@angular/http';
import { CategoryApi, HttpClient, PriceApi} from '../services/webservice';
import { Category, PriceLevel } from '../models';
import * as ui from "../models/ui";
import { UnsafeAction } from '../actions/UnsafeAction';

@Injectable()
export class CategoryFormEffect {
	constructor(
		private updates$: Actions,
		private store: Store<AppState>,
		private categoryApi: CategoryApi,
		private priceApi: PriceApi,
		private categoryFormActions: CategoryFormActions,
		private messageActions:MessageActions,
		private httpClient: HttpClient,
		private errorHandler: ErrorHandlerService
	) { }


	@Effect() saveDisplayCategory$ = this.updates$
		.ofType(CategoryFormActions.SAVE_DISPLAY_CATEGORY)
		.withLatestFrom(this.store)
		.flatMap(([action,state]: [UnsafeAction, AppState]) =>
			 this.saveCategories(state.categoryForm.displayCategories, action.payload)
				.flatMap(categories =>
					this.savePriceLevel(state.categoryForm.displayCategories, categories)
					.map(combinedPriceLevels=>this.categoryFormActions.categoryAndPriceLevelSaved(categories,combinedPriceLevels))
				)
				.catch((error) => Observable.of(this.categoryFormActions.error(error)))
		)

	@Effect() forceCategoryDelete$ = this.updates$
		.ofType(CategoryFormActions.FORCE_CATEGORY_DELETE)
		.withLatestFrom(this.store)
		.flatMap(([action, state]) => this.categoryApi.deleteCategory(state.categoryForm.queryForceDelete.category)
			.mapTo(this.categoryFormActions.forceCategoryDeleteSuccess())
			.catch((error) => Observable.of(this.categoryFormActions.error(error)))
		);

	@Effect() forcePriceLevelDelete$ = this.updates$
		.ofType(CategoryFormActions.FORCE_DELETE_REDUCED_PRICELEVEL)
		.withLatestFrom(this.store)
		.flatMap(([action, state]) => this.priceApi.deletePrice(state.categoryForm.queryForceDeletePriceLevel)
			.mapTo(this.categoryFormActions.forcePriceLevelDeleteSuccessful(state.categoryForm.queryForceDeletePriceLevel))
			.catch((error) => Observable.of(this.categoryFormActions.error(error)))
		)

	@Effect() showSuccessMessage$ = this.updates$
		.ofType(
			CategoryFormActions.FORCE_CATEGORY_DELETE_SUCCESS,
			CategoryFormActions.FORCE_DELETE_REDUCED_PRICELEVEL_SUCCESS,
			CategoryFormActions.CATEGORY_AND_PRICELEVEL_SAVED)
			.mapTo(this.messageActions.displayMessage("Ihre Kategorien & Preise wurden erfolgreich gespeichert.", "success"))


	@Effect() displayErrorMessage = this.updates$
		.ofType(CategoryFormActions.CATEGORY_FORM_ERROR)
		.flatMap((action: UnsafeAction) => this.handleError(action.payload, "Leider ist ein Fehler aufgetreten. Die Aktion war nicht erfolgreich."))


	private saveCategories(dcs: ui.DisplayCategory[],collectionUrl:string) {
		return Observable.from(dcs)
			.concatMap(dc => this.createOrUpdateCategory(dc.category))
			.toArray()
			.let(this.linkCategories(collectionUrl))
	}

	private savePriceLevel(dcs: ui.DisplayCategory[], categories:Category[]) {
		return Observable.from(categories)
			.flatMap(category => {
				const displayCategory = dcs.find(dc => dc.combinedPriceLevel.categoryID == category.uuid)
				const saveStandard = this.saveStandard(category._links.standardPriceLevel.href, displayCategory.combinedPriceLevel.standard)
				return saveStandard
					.flatMap(savedStandard=>
						 this.saveReduced(category._links.reducedPriceLevels.href,displayCategory.combinedPriceLevel.reduced)
						 .map(saveReduced =>  { return {categoryID:category.uuid,standard:savedStandard,reduced:saveReduced}} )
					)
			})
			.toArray()
	}

	private createOrUpdateCategory(category: Category) {
		if (category._links) return this.categoryApi.updateCategory(category)
		else return this.categoryApi.createCategory(category);
	}
	private createOrUpdatePriceLevel(pl: PriceLevel) {
		return pl._links ? this.priceApi.updatePrice(pl) : this.priceApi.createPrice(pl)
	}

	private linkCategories(collectionUrl) {
		return (ob: Observable<Category[]>) =>
			ob.flatMap(categories =>
				this.categoryApi.linkCategory(
					collectionUrl, categories.map(cat => cat._links.self.href)
				).mapTo(categories)
			)
	}

	private saveStandard(collectionUrl: string, standard: PriceLevel): Observable<PriceLevel> {
 		return this.createOrUpdatePriceLevel(standard)
				.flatMap(savedPriceLevel => Observable.of(savedPriceLevel)
					.flatMap(pl => this.httpClient.putRef(collectionUrl, [pl._links.self.href]))
					.mapTo(savedPriceLevel)
		)
	}

	private saveReduced(collectionUrl: string, reduced: PriceLevel[]): Observable<PriceLevel[]> {
		if (reduced.length == 0) return Observable.of([]);

		return Observable.forkJoin(reduced.map(reduced=>this.createOrUpdatePriceLevel(reduced)))
			.flatMap(savedPriceLevels => Observable.of(savedPriceLevels)
				.flatMap(spls => this.httpClient.patchRef(collectionUrl, spls.map(spl=>spl._links.self.href)))
				.mapTo(savedPriceLevels)
			)
	}

	private handleError(error: Response, defaultMessage:string): Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error,	defaultMessage)
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
	}
}


// WEBPACK FOOTER //
// ./src/app/effects/category-form.effect.ts